import axiosInstance from "@/api/axiosInstance";
import { ResyncCompanyFromSalesforceResponse } from "./types";

export const resyncCompanyFromSalesforce = async (
  uuid: string,
): Promise<ResyncCompanyFromSalesforceResponse> => {
  const response =
    await axiosInstance.post<ResyncCompanyFromSalesforceResponse>(
      `/api/private/companies/${uuid}/resync-from-salesforce`,
    );
  return response.data;
};
